import { parsePromoParams } from './promoParams';
import { setPromoRecord } from './promoStorage';

/**
 * ORT-3077: capture a `?promo=` newsletter deep link on ANY page. This runs from the
 * always-loaded app bundle (not just PDPs), so the newsletter can link anywhere and still
 * pre-store the code, with no need to mention it on the target page.
 *
 * Deliberately does no validation or banner rendering (that stays on the PDP via usePromoCode).
 * We only persist the code so it applies at add-to-cart and surfaces on later PDPs. The anchor
 * is null (a non-PDP landing page has no product context); product scoping then relies on the
 * o-number list (?pron=). On a PDP deep link, usePromoCode later refines the record with a
 * proper anchor / clears it if Pimcore reports the code invalid.
 */
export function capturePromoFromUrl(): void {
  if (typeof window === 'undefined') return;
  const parsed = parsePromoParams(window.location.search);
  if (!parsed) return;

  setPromoRecord({
    code: parsed.code,
    scope: parsed.scope,
    anchor: null,
    applyMode: parsed.applyMode,
    oNumbers: parsed.oNumbers,
    suppressOffers: parsed.suppressOffers,
  });
}
